import {
	Box,
	IconButton,
	List,
	ListItem,
	ListItemText,
	Popover,
	Tooltip,
	Typography
} from "@material-ui/core";

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import lod_ from "lodash";
import cockpitActions from "../../redux/actions/cockpitActions";
import LoopIcon from "@material-ui/icons/Loop";
import AddIcon from "@material-ui/icons/Add";
import i18n from "i18n";

export default function SwitchSignature({ insert = false }) {
	const dispatch = useDispatch();

	const { assistantconfig, answers } = useSelector(state => state);
	const { selectedConversation, userStatus } = useSelector(state => state.cockpit);
	const [alternatives, setalternatives] = useState([]); // List of alternatives of signature

	const [anchor, setAnchorElSignature] = useState(null);
	const [open, setOpen] = useState(false);

	const handleOpenSwitchSignaturePop = event => {
		setAnchorElSignature(event.currentTarget);
		setOpen(true);
	};

	const handleOpenAddSignaturePop = event => {
		if (alternatives.length === 1) {
			dispatch(
				cockpitActions.computeSignature(
					selectedConversation?.header?.assistantID,
					selectedConversation?.header?.fID
				)
			);
		} else {
			setAnchorElSignature(event.currentTarget);
			setOpen(true);
		}
	};

	const handleCloseSwitchSignaturePop = () => {
		setAnchorElSignature(null);
		setOpen(false);
	};

	const getAnswerSignature = code => {
		if (!lod_.isNil(answers?.data) && !lod_.isEmpty(answers?.data)) {
			const answerItem = answers?.data.find(c => c.code === code && c.active === true);
			return answerItem;
		} else {
			return null;
		}
	};

	const getChannel = () => {
		const channel = assistantconfig?.channels.find(
			c => c.code === selectedConversation?.header?.extra?.channelCode
		);
		return channel;
	};

	useEffect(() => {
		const channel = getChannel();

		if (
			!lod_.isNil(channel) &&
			!lod_.isNil(channel?.signatureCode) &&
			!lod_.isEmpty(channel?.signatureCode)
		) {
			const signatureCode = channel.signatureCode;
			const answersSignature = getAnswerSignature(signatureCode);

			if (
				!lod_.isNil(answersSignature) &&
				!lod_.isEmpty(answersSignature) &&
				!lod_.isNil(answersSignature?.content)
			) {
				const language = selectedConversation?.header?.language || userStatus?.auth?.user?.language;

				const content = answersSignature?.content.map(item => {
					return item[language.toUpperCase()] || item[language.toLowerCase()];
				});

				if (!lod_.isNil(content)) {
					setalternatives(content);
				} else {
					setalternatives([]);
				}
			} else {
				setalternatives([]);
			}
		} else {
			setalternatives([]);
		}
	}, [selectedConversation?.header?.fID]);

	const switchAlternative = index => {
		dispatch(
			cockpitActions.computeSignature(
				selectedConversation?.header?.assistantID,
				selectedConversation?.header?.fID,
				index
			)
		);
		handleCloseSwitchSignaturePop();
	};

	return (
		<Box>
			{!insert && alternatives.length > 1 && (
				<Tooltip title={i18n.t("COC.switchSignature")} placement="top">
					<IconButton onClick={handleOpenSwitchSignaturePop}>
						<LoopIcon />
					</IconButton>
				</Tooltip>
			)}

			{insert && !lod_.isEmpty(alternatives) && (
				<Tooltip title={i18n.t("COC.addSignature")} placement="top">
					<IconButton onClick={handleOpenAddSignaturePop}>
						<AddIcon />
					</IconButton>
				</Tooltip>
			)}

			<Popover
				id={open ? "simple-popover" : undefined}
				open={open}
				anchorEl={anchor}
				onClose={handleCloseSwitchSignaturePop}
				anchorOrigin={{
					vertical: "center",
					horizontal: "right"
				}}
				transformOrigin={{
					vertical: "center",
					horizontal: "left"
				}}
			>
				{lod_.isEmpty(alternatives) || lod_.isNil(alternatives) ? (
					<Typography>Aucune alternative trouvée</Typography>
				) : (
					<List>
						{alternatives.map((alternative, key) => (
							<ListItem button key={key} onClick={() => switchAlternative(key)}>
								<ListItemText primary={`Alternative ${key + 1}`} />
							</ListItem>
						))}
					</List>
				)}
			</Popover>
		</Box>
	);
}
